export default {
    'provider.text.default.data': 'The Yangtze River rolls eastward',
    'provider.panel': 'Panel',
    'provider.text': 'Text',
    'provider.text.time': 'Time Text',
    'provider.image': 'Image',
    'provider.data.table': 'Data Table',
    'provider.free.table': 'Free Table',
    'provider.rect': 'Rectangle',
    'provider.horizontal.line': 'Horizontal Line',
    'provider.dotted.horizontal.line': 'Dotted Horizontal Line',
    'provider.vertical.line': 'Vertical Line',
    'provider.dotted.vertical.line': 'Dotted Vertical Line',
    'provider.container': 'Container',
    'provider.page.header': 'Page Header',
    'provider.page.footer': 'Page Footer',
    'provider.page.num': 'Page Number',
    'provider.svg.polygon line': 'Polygon',
    'provider.svg.line': 'Line',
    'provider.svg.bezier.curve': 'Bezier Curve',
    'provider.svg.bezier.curve.three': 'Bezier Curve 3',
    'provider.svg.circle': 'Circle',
    'provider.svg.ellipse': 'Ellipse',
    'provider.draw.panel': 'Drawing Board'
};
